 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","views-home-home-module":"views-home-home-module","views-patient-worklist-patient-worklist-module":"views-patient-worklist-patient-worklist-module","views-settings-settings-module":"views-settings-settings-module","default~views-onboarding-onboarding-module~views-patient-patient-module":"default~views-onboarding-onboarding-module~views-patient-patient-module","views-patient-patient-module":"views-patient-patient-module","default~views-onboarding-onboarding-module~views-profile-profile-module":"default~views-onboarding-onboarding-module~views-profile-profile-module","views-profile-profile-module":"views-profile-profile-module","views-onboarding-onboarding-module":"views-onboarding-onboarding-module","pages-account-verified-account-verified-module":"pages-account-verified-account-verified-module","pages-forgot-password-forgot-password-module":"pages-forgot-password-forgot-password-module","pages-reset-password-reset-password-module":"pages-reset-password-reset-password-module","pages-sign-up-sign-up-module":"pages-sign-up-sign-up-module","pages-verify-email-verify-email-module":"pages-verify-email-verify-email-module","pages-verify-verify-module":"pages-verify-verify-module","views-inpatients-inpatients-module":"views-inpatients-inpatients-module","views-loa-loa-module":"views-loa-loa-module","views-medical-billing-medical-billing-module":"views-medical-billing-medical-billing-module","views-patient-registration-patient-registration-module":"views-patient-registration-patient-registration-module","views-patients-admin-patients-module":"views-patients-admin-patients-module","views-patients-patients-module":"views-patients-patients-module","views-referrals-referrals-module":"views-referrals-referrals-module","views-reports-reports-module":"views-reports-reports-module","views-staff-accounts-staff-accounts-module":"views-staff-accounts-staff-accounts-module","views-teleconsultation-teleconsultation-module":"views-teleconsultation-teleconsultation-module","views-teleconsults-teleconsults-module":"views-teleconsults-teleconsults-module"}[chunkId]||chunkId) + "." + {"common":"38f3e8420dee1e8ac0d6","views-home-home-module":"85db124fa8622dfb4d24","views-patient-worklist-patient-worklist-module":"13886dfc33a94e3b3c7b","views-settings-settings-module":"4e675347d2490e843e74","default~views-onboarding-onboarding-module~views-patient-patient-module":"aeeddab68a212b0c2ea9","views-patient-patient-module":"7e5a71146b18ba10d73f","default~views-onboarding-onboarding-module~views-profile-profile-module":"d5e67b3c32c19434534d","views-profile-profile-module":"85cf0d78081b9656a8bf","views-onboarding-onboarding-module":"75ddc3b88522d49451b9","pages-account-verified-account-verified-module":"968ea42d38df36aacf51","pages-forgot-password-forgot-password-module":"c332d44436b19a369678","pages-reset-password-reset-password-module":"ea9a01fb32fbc0b5c5a6","pages-sign-up-sign-up-module":"72bb060dd6ab3dd7dc2b","pages-verify-email-verify-email-module":"26e0ae9b61142108acc6","pages-verify-verify-module":"d9dfaf8d7f9a6f903f16","views-inpatients-inpatients-module":"66e3cdc322ef16c4c414","views-loa-loa-module":"3ac2b0f3c5226bf43551","views-medical-billing-medical-billing-module":"80de316ba9d152fb7475","views-patient-registration-patient-registration-module":"ff1071e3db35bace883f","views-patients-admin-patients-module":"ab27d4ef054cac658e25","views-patients-patients-module":"af46943369651b839492","views-referrals-referrals-module":"26c95fc2529fc5a4978f","views-reports-reports-module":"1ccc4de5d4470cf40134","views-staff-accounts-staff-accounts-module":"4a3c0de173dd4dede20d","views-teleconsultation-teleconsultation-module":"ed0cb4fede34199d319b","views-teleconsults-teleconsults-module":"7e494d9351396f292273"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
